<template>
  <form @submit.prevent="saveReport">
    <div class="px-4 py-2 mb-3 text-red-700 bg-red-200 rounded-md" v-if="form_errors.length">
      <div v-for="error in form_errors" :key="error.message">
        {{ error.message }}
      </div>
    </div>
    <fieldset class="form-group">
      <label for="name" class="form-label">
        Name
      </label>
      <input type="text" name="name" id="name" class="form-input" v-model="form.name">
      <validations :errors="errors" field="name" />
    </fieldset>
    <fieldset class="form-group">
      <label for="description" class="form-label">
        Description <div class="ml-2 text-xs text-gray-500">Optional</div>
      </label>
      <input type="text" name="description" id="description" class="form-input" v-model="form.description">
      <validations :errors="errors" field="description" />
    </fieldset>
    <!-- <div class="grid gap-4 sm:grid-cols-2">
      <fieldset class="form-group">
        <label for="visibility" class="form-label">
          Visiblity
        </label>
        <radio-group v-model="form.visibility"
          :options="[
            { label: `Only Me`, value: 'private' },
            { label: `Everyone`, value: 'public' }
          ]" />
        <validations :errors="errors" field="visibility" />
      </fieldset>
      <fieldset class="form-group">
        <label for="format" class="form-label">
          Format
        </label>
        <radio-group v-model="form.format"
          :options="[
            { label: `CSV`, value: 'csv' },
            { label: `PDF`, value: 'pdf' }
          ]" />
        <validations :errors="errors" field="format" />
      </fieldset>
    </div> -->
    <fieldset class="grid items-center grid-cols-3 form-group">
      <label class="form-label">
        Pull data from the last
      </label>
      <div class="flex col-span-2">
        <input type="number" min="1" class="flex-shrink w-20 mr-2 form-input" v-model="form.period_quantity">
        <select name="period_unit" id="period_unit" class="flex-grow w-40 form-select" v-model="form.period_unit">
          <option value="days">Day(s)</option>
          <option value="weeks">Week(s)</option>
          <option value="months">Month(s)</option>
        </select>
      </div>
      <validations :errors="errors" field="period-quantity" />
      <validations :errors="errors" field="period_unit" />
    </fieldset>
    <div class="p-6 bg-gray-100 rounded">
      <fieldset>
        <label class="flex items-center m-0 form-label">
          <toggle :value.sync="form.scheduled" :sync="true" :width="60" class="mr-4" /> 
          Send on a Schedule
        </label>
      </fieldset>
      <Collapse :active="form.scheduled" :duration="200">
        <div class="grid gap-4 mt-6 sm:grid-cols-2">
          <fieldset class="form-group">
            <label for="visibility" class="form-label">
              Send Every:
            </label>
            <div class="flex">
              <!-- <input type="number" class="rounded-r-none form-input" v-model="form.recurrence"> -->
              <select name="" id="" class="form-select" v-model="form.frequency">
                <option value="day">Day</option>
                <option value="week">Week</option>
                <option value="month">Month</option>
              </select>
            </div>
            <validations :errors="errors" field="reccurence" />
            <validations :errors="errors" field="frequency" />
          </fieldset>
          <fieldset class="form-group">
            <label for="time_of_day" class="form-label">
              At This Time:
            </label>
            <time-picker v-model="form.time_of_day" :minute-increment="15" :input-props="{ class: 'form-input' }"/>
            <validations :errors="errors" field="time_of_day" />
          </fieldset>
        </div>
        <fieldset class="form-group" v-if="form.frequency === 'week'">
          <label for="day_of_week" class="form-label">
            On This Day of the Week:
          </label>
          <div class="grid grid-flow-col grid-cols-7 p-2 text-center text-gray-500 border border-gray-300 rounded">
            <label v-for="day in week" :key="day" class="flex flex-col items-center justify-center p-3 text-sm font-medium leading-none rounded cursor-pointer hover:bg-white" :class="{ 'bg-indigo-500 text-white hover:bg-indigo-500': day.number === form.day_of_week }">
              <input type="radio" name="day_of_week" class="absolute opacity-0 pointer-events-none" :value="day.number" v-model="form.day_of_week">
              {{ day.name }}
            </label>
          </div>
          <validations :errors="errors" field="day_of_week" />
        </fieldset>
        <fieldset class="form-group" v-if="form.frequency === 'month'">
          <label for="day_of_month" class="form-label">
            On This Day of the Month:
          </label>
          <div class="grid grid-cols-7 p-2 text-gray-500 border rounded">
            <label v-for="day in month" :key="day.number" class="flex flex-col items-center justify-center p-3 text-sm font-medium leading-none rounded cursor-pointer hover:bg-white" :class="{ 'col-span-7': day.number === -1, 'bg-indigo-500 text-white hover:bg-indigo-500': day.number === form.day_of_month }">
              <input type="radio" name="day_of_month" class="absolute opacity-0 pointer-events-none" :value="day.number" v-model="form.day_of_month" >
              {{ day.name }}
            </label>
          </div>
          <validations :errors="errors" field="day_of_month" />
        </fieldset>
        <fieldset class="form-group">
          <label for="contacts" class="form-label">
            To These Recipients:
          </label>
          <contact-toggle :parent="form" type="email" @toggle="toggleContact" />
        </fieldset>
      </Collapse>
    </div>

    <div class="flex justify-between mt-6">
      <button class="mt-6 btn btn-primary" type="submit" v-submitting="submitting">
        {{ form.scheduled ? 'Save & Schedule Report' : 'Save Report' }}
      </button>

      <button v-if="$route.params.id" class="mt-6 text-red-500 btn" type="button" v-submitting="submitting" @click="deleteReport">
        Delete Report
      </button>
    </div>
  </form>
</template>

<script>
import TimePicker from '@/components/TimePicker'

export default {
  name: 'ReportForm',

  components: {
    TimePicker
  },

  props: {
    filter: {
      type: Object,
      required: true
    },

    report: {
      type: Object
    }
  },

  created () {
    if (this.report) {
      this.form = JSON.parse(JSON.stringify(this.report))
    }
  },

  computed: {
    week () {
      return [
        { name: 'Mon', number: 1 },
        { name: 'Tue', number: 2 },
        { name: 'Wed', number: 3 },
        { name: 'Thu', number: 4 },
        { name: 'Fri', number: 5 },
        { name: 'Sat', number: 6 },
        { name: 'Sun', number: 7 }
      ]
    },

    month () {
      let days = []
      for (let i = 1; i <= 28; i++) {
        days.push({ name: i, number: i })
      }
      days.push({ name: 'Last Day of Month', number: -1 })
      return days
    }
  },

  data () {
    return {
      submitting: false,
      errors: [],
      form_errors: [],
      form: {
        type: this.$route.params.type,
        name: '',
        description: '',
        visibility: 'public',
        format: 'csv',
        period_quantity: 1,
        period_unit: 'days',
        scheduled: false,
        frequency: 'day',
        recurrence: 1,
        day_of_week: 1,
        day_of_month: 1,
        time_of_day: '09:00',
        emails: []
      }
    }
  },

  methods: {
    toggleContact (type, contact) {
      let index = this.form.emails.findIndex(c => c.id === contact.id)

      if (index > -1) {
        this.$delete(this.form.emails, index)
      } else {
        this.$set(this.form.emails, this.form.emails.length, contact)
      }
    },

    async saveReport () {
      try {
        this.submitting = true

        if (this.$route.params.id) {
          await this.$api.patch(`account/${this.$route.params.account}/reports/${this.$route.params.id}`, { 
            ...this.form,
            filter: this.filter
          })
        } else if (this.$route.params.type) {
          await this.$api.post(`account/${this.$route.params.account}/reports`, { 
            ...this.form,
            filter: this.filter
          })
        } else {
          console.error('No report type or ID specified.')
        }
        
        this.$router.push({ name: 'ReportList' })
      } catch (error) {
        console.error(error)
        this.errors = error.response.data.errors ? error.response.data.errors : []
        this.form_errors = error.response.data.form_errors ? error.response.data.form_errors : []
      } finally {
        this.submitting = false
      }
    },

    async deleteReport () {
      if (window.confirm('Are you sure you want to delete this report?')) {
        try {
          this.submitting = true
          await this.$api.delete(`account/${this.$route.params.account}/reports/${this.$route.params.id}`)
          this.$toasted.show('Report deleted.')
          this.$router.push({ name: 'ReportList' })
        } catch (error) {
          console.error(error)
          this.errors = error.response.data.errors ? error.response.data.errors : []
          this.form_errors = error.response.data.form_errors ? error.response.data.form_errors : []
        } finally {
          this.submitting = false
        }
      }
    }
  },
}
</script>